import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";

export interface PhoneCallsDisconnectAlertProps {
  isOpen: boolean;
  phoneNumber: string;
  onRequestClose: () => void;
  onConfirm: () => void;
}

/**
 * Warns that the Phone Calls account (and its associated number) will be
 * disconnected forever if the user proceeds with a free-plan downgrade.
 * Confirm does not disconnect the account itself — it only continues to the
 * existing downgrade confirmation.
 */
export const PhoneCallsDisconnectAlert: FC<PhoneCallsDisconnectAlertProps> = ({
  isOpen,
  phoneNumber,
  onRequestClose,
  onConfirm,
}) => {
  const { t } = useTranslations();

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      textAlignment="left"
      title={t({
        id: "subscription-plans-dialog.phone-calls-will-be-disconnected-title",
        defaultMessage: "⚠️ Phone calls will be disconnected",
      })}
      content={t(
        {
          id: "subscription-plans-dialog.phone-calls-disconnect-warning",
          defaultMessage:
            "Phone Calls feature available only in Paid Plans. By confirming this action your Phone Calls account with {phoneNumber} associated phone number will be disconnected forever",
        },
        {
          phoneNumber: (
            <span className="font-medium text-primary">{phoneNumber}</span>
          ),
        }
      )}
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          color: "grey",
          role: "close",
        },
        {
          text: t({
            id: "subscription-plans-dialog.confirm-and-proceed",
            defaultMessage: "Confirm & Proceed",
          }),
          color: "tertiary",
          onClick: () => {
            onConfirm();
          },
        },
      ]}
    />
  );
};
